export default __webpack_public_path__ + "static/media/icon_building.8a2b43e1.svg";